'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  default: null,
  checkbox: null,
  radio: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/constants/SelectableBoxTypes.js
// module id = 442
// module chunks = 0